import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton = ({ button_id, image_id, steps=-1, to=null, customBack=null }) => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (customBack) { customBack(); }
    else if (to) { window.location.reload(); }
    else { navigate(steps); }
  }

  return (
    <button onClick={handleGoBack} className={`back_buttons ${button_id}`}>
      <img src={`${process.env.PUBLIC_URL}/images/back_button_arrow.png`} className={image_id} alt="back"/>
    </button>
  );
};

export default BackButton;
